import { API } from '../../config/api/index';

//ALL TYPE WISE DATA RETURN
const initState = {
    supplierData: {},
    supplierDetail: {},
    noteList: [],
    supplierInvoiceData: [],
    supplierInvoiceList: [],
    supplierInvoiceDetail: {},
};

//DEFINE ACCOUNT REDUCER FUNCTION
const SupplierReducer = (state = initState, action) => {
    switch (action.type) {
        case 'CLEAR_SUPPLIER_INVOICE_DETAIL':
            return {
                ...state,
                supplierInvoiceDetail: {}, // or null/undefined depending on how you handle it
            };
        case API.supplier.getlist:
            return {
                ...state,
                supplierData: action.supplierData,
            };
        case API.supplier.getDetail:
            return {
                ...state,
                supplierDetail: action.supplierDetail,
            };
        case API.supplier.notes.get:
            return {
                ...state,
                noteList: action.noteList,
            };

        case API.supplier.invoiceList:
            return {
                ...state,
                supplierInvoiceData: action.supplierInvoiceData,
            };
        case API.supplier.supplierInvoice.getList:
            return {
                ...state,
                supplierInvoiceList: action.supplierInvoiceList,
            };

        case API.supplier.supplierInvoice.getSingle:
            return {
                ...state,
                supplierInvoiceDetail: action.supplierInvoiceDetail,
            };
        default:
            return state;
    }
};

//EXPORT ALL FUNCTION
export default SupplierReducer;
